module.exports = __webpack_public_path__ + "static/scale-model-of-fantasy-faire-in-fullerton-california-600767eb018578c10259c22a0a6157f8.png";